import React from 'react';
export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white py-8">
      <div className="max-w-6xl mx-auto px-6 text-center">
        © All Copyright {new Date().getFullYear()} by ஸ்ரீமன் வைகுண்ட நாராயணசுவாமி திருக்கோவில்
      </div>
    </footer>
  )
}